if(typeof dtrace-provider === 'undefined') { var e = new Error("Cannot find module 'dtrace-provider'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = dtrace-provider;